import styled from '@emotion/styled';
import { ButtonV3 } from '../ButtonV3';
import H from '../../typography/Headings';
import P from '../../typography/Paragraphs';
import {
  FeaturedImageWrapper,
  ForegroundImagesWrapper,
  StyledForegroundImage,
  StyledForegroundPicture,
} from './FeaturedImage.styles';
import COLORS3 from '../../styles/emotion/colors3';
import FONT from '../../styles/emotion/fonts';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import SPACING from '../../styles/emotion/spacing';

export const GridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid ${COLORS3.BLACK_030};

  ${MEDIA_QUERY_V2.MOBILE} {
    display: flex;
    flex-direction: column;
  }
`;

export const GridItemWrapper = styled.div`
  position: relative;
  width: 50%;

  ${MEDIA_QUERY_V2.MOBILE} {
    width: 100%;
  }

  ${FeaturedImageWrapper} {
    height: 100%;
    padding: ${SPACING.S16};
  }

  ${ForegroundImagesWrapper} {
    height: 100%;
    width: 100%;
  }

  ${StyledForegroundPicture} {
    height: auto;
  }

  ${StyledForegroundImage} {
    border-radius: ${SPACING.S16};
  }
`;

export const GridTextWrapper = styled(GridItemWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${SPACING.S24} ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    border-bottom: 1px solid ${COLORS3.BLACK_030};
  }

  ${MEDIA_QUERY_V2.TABLET} {
    padding: ${SPACING.S24};
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    padding: ${SPACING.LG};
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    padding: 56px;
  }

  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    padding: 64px;
  }
`;

export const GridRow = styled.div`
  display: flex;
  flex-direction: column;

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    flex-direction: row;
    border-bottom: 1px solid ${COLORS3.BLACK_030};
    &:nth-of-type(even) {
      flex-direction: row-reverse;
      ${GridItemWrapper} {
        border-left: 1px solid ${COLORS3.BLACK_030};
      }
    }
    &:nth-of-type(odd) {
      ${GridTextWrapper} {
        border-left: 1px solid ${COLORS3.BLACK_030};
      }
    }
  }
`;

export const StyledHTitleMedium4 = styled(H.TitleMedium4)`
  ${MEDIA_QUERY_V2.TABLET} {
    ${FONT.textSizeCompact(FONT.SIZE.LARGE)}
  }
`;

export const StyledPBodyBase = styled(P.BodyBase)`
  margin: ${SPACING.S16} 0 ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    margin: ${SPACING.XS} 0 ${SPACING.S16};
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    ${FONT.textSizeRegular(FONT.SIZE.REGULAR)}
  }
`;

export const GridButton = styled(ButtonV3)`
  align-self: self-start;
`;

export const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: ${SPACING.S16};
`;

export const Video = styled.video`
  width: 100%;
  border-radius: ${SPACING.S16};
`;
